/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    export class BmPracticeWidgetInvoiceService {

        static $inject = [
            '$translate',
            '$q',
            '$window',
            '$uibModal',
            '$rootScope',
            'bmpBigNumberUtils',
            'bmPracticeBillingSendModalService',
            'csAccountsReceivableTypeV1',
            'csAccountsReceivableV1',
            'csAccountsReceivableAppliedAmountV1',
            'csReportV1'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService,
            private $q: ng.IQService,
            private $window: ng.IWindowService,
            private $uibModal: angular.ui.bootstrap.IModalService,
            private $rootScope: ng.IRootScopeService,
            private bigNumber: bmp.globalize.IBigNumberUtils,
            private sendModalService: any,
            private accountsReceivableTypeV1: cs.IAccountsReceivableTypeV1Service,
            private accountsReceivableV1: cs.IAccountsReceivableV1Service,
            private accountsReceivableAppliedAmountV1: cs.IAccountsReceivableAppliedAmountV1Service,
            private reportService: cs.IReportV1Service) {
                // Nothing required here
        }

        /** Opens a new browser window/tab to preview the invoice */
        public preview(id: string): ng.IPromise<any> {

            let self = this;
            return this.reportService.createDocumentPreviewUrl({}).then(response => {
                self.$window.open(response.Url + '&invoiceAccountsReceivableIds=' + id);
            });

        }

        /** Displays a modal with options for sending the invoice */
        public send(id: string): void {
            this.sendModalService.displaySendModalForInvoices([{ id: id }]);
        }

        /** Displays a modal with the bilable entries */
        public showBillableEntries(id: string): ng.IPromise<void> {

            var options: ng.ui.bootstrap.IModalSettings = {
                backdrop: 'static',
                templateUrl: 'practice-widgets/billing-services/billable-entries-dialog.html',
                controller: 'bmPracticeWidgetBillableEntriesDialogController as billableEntriesDialog',
                windowClass: 'billable-entries-dialog-window',
                resolve: {
                    invoiceId: () => id
                }
            };
            var modalInstance = this.$uibModal.open(options);
            return modalInstance.result;

        }

        /** Displays a modal with the applied amounts */
        public showAppliedAmounts(id: string): ng.IPromise<void> {

            return this._getARTypes().then(typeData => {
                return this.accountsReceivableV1.get({ accountsReceivableId: id }).then(arData => {
                    return this.accountsReceivableAppliedAmountV1.get({ id: id }).then(arApplicationsData => {
                        var modalScope: { appliedAmounts?: any, receiptAmount?: any, categoryId?: any } & ng.IScope = this.$rootScope.$new();
                        modalScope.appliedAmounts = arApplicationsData;
                        modalScope.receiptAmount = this.bigNumber.safeParseBigNumber(arData.amount).times(arData.normalSign).toString();
                        modalScope.categoryId = _.findWhere(typeData, { id: arData.accountsReceivableType.id }).categoryId;
                        return this.$uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'main/src/entry-form/applied-amounts-popup.html',
                            controller: 'bm.practice.receiptAndAdjustment.AppliedAmountsPopupController',
                            controllerAs: 'ctrl',
                            scope: modalScope,
                            size: 'lg'
                        }).result.then((result: any) => {
                            return this.accountsReceivableAppliedAmountV1.put({ id: id, dto: result }).then(response => {
                                return;
                            });
                        });
                    });
                });
            });

        }

        // Caches the A/R types
        private _arTypes: cs.IAccountsReceivableTypeV1Dto[] = undefined;
        private _getARTypes(): ng.IPromise<cs.IAccountsReceivableTypeV1Dto[]> {
            let self = this;
            return !!this._arTypes ? this.$q.when(this._arTypes) : this.accountsReceivableTypeV1.getListFiltered({}).then(typeData => {
                self._arTypes = typeData.items;
                return self._arTypes;
            });
        }

    }

    /** Controller for the billable entries dialog */
    export class PracticeWidgetBillableEntriesDialogController {

        public serviceProxy: bmp.IRepositoryService;
        public gridData: bmp.IGridData;
        public gridDefinition: bmp.IGridDefinition;

        static $inject = [
            '$scope',
            '$timeout',
            '$uibModalInstance',
            'csAccountsReceivableInvoiceV1',
            'invoiceId'
        ];
        constructor(
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private $uibModalInstance: any,
            private service: cs.IAccountsReceivableInvoiceV1Service,
            private invoiceId: string) {

            // Dismiss when the url changes
            $scope.$on('$locationChangeSuccess', function() {
                $uibModalInstance.dismiss('cancel');
            });

            // $uibModalInstance.rendered.then(() => {
            //     $scope.$broadcast('bmpWijmoTable$repaintGrid');
            // });

            // Create a service proxy because the details are only available as a child of the parent object
            let self = this;
            let wrapInGetListDto = (items: any[]) => {
                return { items: items, itemsPerPage: items.length, pageIndex: 1, startIndex: 1, totalItems: items.length, totalPages: 1 };
            };
            this.serviceProxy = <any>{
                getList: () => {
                    return self.service.getInvoice({ accountsReceivableId: self.invoiceId }).then((data) => {
                        return wrapInGetListDto(_.filter(data.invoice.invoiceDetails, (invoiceDetail) => invoiceDetail.timeAndExpense.activityClass.id === 'BILLABLE'));
                    });
                }
            };

            // Grid & toolbar definition
            this.gridDefinition = {
                gridName: 'billableEntriesGrid',
                analyticsContext: 'billableEntries',
                affectUrl: false,
                primaryKey: 'id',
                hideFooter: true,
                hasSearch: false,
                addButton: false,
                editButton: false,
                deleteButton: false,
                isSelectable: false,
                exportButton: false,
                isEditable: true,
                editingDisabled: true,
                groupButton: true,
                filterButton: false,
                actionsColumnVisible: false,
                toolbarButtons: [],
                appendToParent:'div.modal-content',
                columns: [
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.EntryDate',
                        dataProperty: 'timeAndExpense.entryDate',
                        width: '100',
                        sortable: false,
                        format: 'date',
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Employee',
                        dataProperty: 'timeAndExpense.employee.name',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Engagement',
                        dataProperty: 'timeAndExpense.engagement.name',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.ProjectScheduleItem',
                        dataProperty: 'timeAndExpense.projectScheduleItem.name',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Activity',
                        dataProperty: 'timeAndExpense.activity.name',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Hours',
                        dataProperty: 'timeAndExpense.hours',
                        format: 'n2',
                        align: 'right',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Units',
                        dataProperty: 'timeAndExpense.units',
                        format: 'n2',
                        align: 'right',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetailAmounts.WorkInProgressAmount',
                        dataProperty: 'amounts.workInProgressAmount',
                        format: 'c2',
                        align: 'right',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetailAmounts.BilledAmount',
                        dataProperty: 'amounts.billedAmount',
                        format: 'c2',
                        align: 'right',
                        width: '100',
                        sortable: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetailAmounts.AdjustmentAmount',
                        dataProperty: 'amounts.adjustmentAmount',
                        format: 'c2',
                        align: 'right',
                        width: '100',
                        sortable: false,
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetailAmounts.CarryoverAmount',
                        dataProperty: 'amounts.carryoverAmount',
                        format: 'c2',
                        align: 'right',
                        width: '100',
                        sortable: false,
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetailAmounts.IndirectTax',
                        dataProperty: 'amounts.indirectTax',
                        format: 'c2',
                        align: 'right',
                        width: '100',
                        sortable: false,
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.InvoiceDetail.IndirectTaxDetail',
                        dataProperty: 'indirectTaxDetail',
                        width: '100',
                        sortable: false,
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.Comment',
                        dataProperty: 'timeAndExpense.comment',
                        width: '100',
                        sortable: false,
                        visible: false
                    },
                    {
                        title: /* i18nextract */'Core.Captions.TimeAndExpense.BillerNote',
                        dataProperty: 'timeAndExpense.billerNote',
                        width: '100',
                        sortable: false,
                        visible: false
                    }
                ]
            };

        }

        // Occurs when the grid is initialized
        public gridLoaded($sender: bmp.IGridData): void {
            this.gridData = $sender;
        }

        // Occurs when the user clicks on the 'x'
        public onClose(): void {
            this.$uibModalInstance.dismiss('close');
        }

        // Occurs when the user clicks the 'cancel' button
        public onCancel(): void {
            this.$uibModalInstance.dismiss('cancel');
        }

        // Occurs when the user clicks the 'import' button
        public onOk(): void {
            this.$uibModalInstance.close('done');
        }

    }

    /** Controller for the applied amounts dialog */
    export class PracticeWidgetAppliedAmountsDialogController {

        public serviceProxy: bmp.IRepositoryService;
        public gridData: bmp.IGridData;
        public gridDefinition: bmp.IGridDefinition;

        static $inject = [
            '$scope',
            '$uibModalInstance',
            'csAccountsReceivableAppliedAmountV1',
            'arItemId'
        ];
        constructor(
            private $scope: ng.IScope,
            private $uibModalInstance: any,
            private service: cs.IAccountsReceivableAppliedAmountV1Service,
            private arItemId: string) {

            // Dismiss when the url changes
            $scope.$on('$locationChangeSuccess', function() {
                $uibModalInstance.dismiss('cancel');
            });

            // Create a service proxy because the details are only available as a child of the parent object
            let self = this;
            let wrapInGetListDto = (items: any[]) => {
                return { items: items, itemsPerPage: items.length, pageIndex: 1, startIndex: 1, totalItems: items.length, totalPages: 1 };
            };
            this.serviceProxy = <any>{
                getList: () => {
                    return self.service.get({ id: self.arItemId }).then((data) => {
                        return wrapInGetListDto(data.applications);
                    });
                }
            };

            // Grid & toolbar definition
            this.gridDefinition = {
                gridName: 'appliedAmountsGrid',
                analyticsContext: 'appliedAmounts',
                affectUrl: false,
                primaryKey: 'id',
                hideFooter: true,
                hasSearch: false,
                addButton: false,
                editButton: false,
                deleteButton: false,
                exportButton: false,
                groupButton: false,
                actionsColumnVisible: false,
                toolbarButtons: [],
                columns: [
                    {
                        title: /* i18nextract */'Core.Captions.AccountsReceivable.AccountsReceivableType',
                        dataProperty: 'accountsReceivable.accountsReceivableType.name',
                        width: 180
                    },
                    {
                        title: /* i18nextract */'Core.Captions.AccountsReceivable.EntryDate',
                        dataProperty: 'accountsReceivable.entryDate',
                        width: 120
                    },
                    {
                        title: /* i18nextract */'Core.Captions.AccountsReceivable.Reference',
                        dataProperty: 'accountsReceivable.reference',
                        width: 300
                    },
                    {
                        title: /* i18nextract */'Core.Captions.AccountsReceivableDetailClosed.AppliedAmount',
                        dataProperty: 'details[0].appliedAmount',
                        format: 'c2',
                        align: 'right',
                        width: 130
                    }]
            };

        }

        // Occurs when the grid is initialized
        public gridLoaded($sender: bmp.IGridData): void {
            this.gridData = $sender;
        }

        // Occurs when the user clicks on the 'x'
        public onClose(): void {
            this.$uibModalInstance.dismiss('close');
        }

        // Occurs when the user clicks the 'cancel' button
        public onCancel(): void {
            this.$uibModalInstance.dismiss('cancel');
        }

        // Occurs when the user clicks the 'import' button
        public onOk(): void {
            this.$uibModalInstance.close('done');
        }

    }

    angular.module('bm.practice.widgets.InvoiceService',
        ['csReportV1', 'csAccountsReceivableTypeV1', 'csAccountsReceivableV1', 'csAccountsReceivableAppliedAmountV1', 'pascalprecht.translate', 'ui.bootstrap.modal', 'bm.practice.billing.sendModal'])
        .controller('bmPracticeWidgetBillableEntriesDialogController', PracticeWidgetBillableEntriesDialogController)
        .service('bmPracticeWidgetInvoiceService', BmPracticeWidgetInvoiceService);
}
